import React from 'react';

import styles from './loading-indicator.scss';

export default function LoadingIndicator() {
  return (
    <div className={styles.main}>
      <span className={styles.text}>Loading</span>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/LoadingIndicator/index.js